import { render, staticRenderFns } from "./MbQuestion.vue?vue&type=template&id=70c3ea12&scoped=true&"
import script from "./MbQuestion.vue?vue&type=script&lang=js&"
export * from "./MbQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MbQuestion.vue?vue&type=style&index=0&id=70c3ea12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3ea12",
  null
  
)

export default component.exports